module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-list-form"
  }, [_c('div', {
    staticClass: "statuses"
  }, _vm._l((['ACTIVE', 'APPROVED', 'SUSPENDED', 'REFUSED', 'ON HOLD', 'PENDING REVIEW']), function(status) {
    return _c('div', {
      staticClass: "ml-3 status"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.search.status),
        expression: "search.status"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": status,
        "checked": Array.isArray(_vm.search.status) ? _vm._i(_vm.search.status, status) > -1 : (_vm.search.status)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.search.status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = status,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.search, "status", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.search, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.search, "status", $$c)
          }
        }
      }
    }), _c('label', [_vm._v(_vm._s(status))])])
  }), 0), _c('div', {
    staticClass: "row"
  }, [(_vm.$isNot('export-form')) ? _c('div', {
    staticClass: "columns shrink"
  }, [_c('a', {
    staticClass: "fa fa-search fa-2x",
    on: {
      "click": function($event) {
        _vm.advanced = !_vm.advanced
      }
    }
  })]) : _vm._e(), (!_vm.advanced) ? _c('div', {
    staticClass: "basic row"
  }, [_c('div', {
    staticClass: "columns ml-2 large-12"
  }, [_c('date-range-picker', {
    on: {
      "input": _vm.dateRangeSelected
    }
  })], 1)]) : _vm._e(), (_vm.advanced) ? _c('div', {
    staticClass: "advanced"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('input-form', {
    attrs: {
      "fields": ['query'],
      "placeholders": ['Driver search']
    },
    on: {
      "updatedData": _vm.setSearch
    }
  })], 1)]) : _vm._e(), (!_vm.advanced && _vm.$isNot('export-form')) ? _c('div', {
    staticClass: "columns small-1 text-right"
  }, [_c('a', {
    staticClass: "fa fa-filter fa-2x",
    on: {
      "click": _vm.setFilters
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bf434e8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/filters/DriverListForm.vue
// module id = 2060
// module chunks = 1